import React, { useEffect, useState } from 'react'
import   './Lessonobjectives.css'
import { useNavigate, useParams } from 'react-router-dom'
import { Container, Row } from 'react-bootstrap'
import { addAnswer } from '../../hook/AnswersCourses'
import { useDispatch, useSelector } from 'react-redux'
function Lessonobjectives({questions}) {
  const {id}=useParams();
  const dispatch=useDispatch();
  const navigate=useNavigate();
      const { answerQuestion } = useSelector((state) => state);

    const [activeBtn, setActiveBtn] = useState(false);
  
      const data=id==1?`🔹 أن يعرّف مفهوم الأمان الرقمي
      🔹 أن يميّز بين السلوك الآمن وغير الآمن في الفضاء الرقمي
    🔹 أن يُطبق ممارسات الأمان الرقمي في بيئة مركز مصادر التعلم
       `:"klfdklf"
useEffect(() => {

  const found = answerQuestion?.answer?.find(
    (c) => Number(c.course) === Number(id)
  );

  setActiveBtn(!!found);

}, [id, answerQuestion]);
  return (
    <div className='lesson_objectives p-4 mt-4'>
<h5 className='title'>النشاط</h5>
<Container>
              <Row>
                <p className='fw-bold fs-5'>أخترالاجابة الصحيحة :</p>
                {questions.map((item, xindex) => {

                  return (
                    <div className='mt-4'>
                      <h6>{"السؤال"}{xindex + 1}{" : "}{item?.question}</h6>
                      <ul>
                        {item.options.map((op, index) => {
                          return (
                            <li className='py-2 option_answer btn_custom'
                              style={{ display: 'block', width: '80%', margin: '10px 0', backgroundColor: '#d1d1d1ff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer', fontFamily: "Noto Kufi Arabic", color: "#000" }}

                              onClick={() => {
                                const isCorrect = item.options.find((items)=>items?.is_correct==1).option == op?.option ? 1 : 0;

                                dispatch(addAnswer({
                                  question: xindex + 1,   // ← رقم السؤال الصحيح
                                  is_correct: isCorrect,
                                  course: id
                                }));
                                if (item.options.find((items)=>items?.is_correct==1).option == op?.option) {

                                  alert("✅ إجابة صحيحة!");
                                  if (xindex === questions.length - 1) {
                                    setActiveBtn(true)
                                  }

                                } else {

                                  alert(`❌ إجابة خاطئة. الإجابة الصحيحة هي: ${item.options.find((items)=>items?.is_correct==1).option}`);

                                }

                              }}
                            >{"الاجابة"}{" "}{index + 1}{" : "}{op?.option}</li>
                          )
                        })}
                      </ul>
                    </div>
                  )
                })}
                <div className='d-flex justify-content-end mt-4 '>

                  {activeBtn ?
                    <button className="py-2 rounded text-white d-flex align-items-center justify-content-center border-0 px-4" style={{
                      background: "rgba(0, 38, 86, 1)"
                    }}
                      onClick={() => {
              if (id >2) {
                          navigate(`/course_details/${Number(id) - 1}`)
                        } else {
                          navigate(`/`)

                        }
                      }}
                    >الانتقال الي السؤال التالي</button>

                    :
                    <button className=" bg-secondary py-2 rounded text-white d-flex align-items-center justify-content-center border-0 px-4 " disabled>الانتقال الي السؤال التالي</button>

                  }
                </div>
              </Row>
            </Container>
    </div>
  )
}

export default Lessonobjectives